import React from 'react';
import Lottie from 'react-lottie';
import EmergeLoadingLottie from '@/assets/EmergeLogoLoader.json';

const LoadingScreen: React.FC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: EmergeLoadingLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div className="h-dvh w-dvw flex justify-center items-center background-dark-emerge">
      <Lottie options={defaultOptions} height="6.24994rem" width="4.95538rem" />
    </div>
  );
};

export default LoadingScreen;
